import styled from 'styled-components';
import { breakpoints, layout } from '../../theme';

export const TimelineWrapper = styled.div`
  background: currentColor;
  bottom: ${layout.SPACING * 1.75}rem;
  left: -1px;
  position: absolute;
  transition: transform 0.3s ease-in-out, top 0.3s ease-in-out;
  width: 2px;
  z-index: 1;
`;

export const Wrapper = styled.div`
  bottom: 0;
  position: fixed;
  right: ${props => (props.isInactive ? '-50%' : 0)};
  top: 0;
  transition: right 0.3s ease-in-out, width 0.3s ease-in-out;
  width: ${props => (props.isActive ? 100 : 50)}%;

  ${TimelineWrapper} {
    transform: ${props =>
      props.isActive || props.isInactive
        ? `translate3d(0${layout.SPACING * 1.75}rem,0,0)`
        : `translate3d(0,0,0)`};
    top: ${props =>
      props.isActive
        ? `${layout.SPACING * 3}rem`
        : `${layout.SPACING * 1.75}rem`};
  }

  @media ${breakpoints.MOBILE__MQ} {
    bottom: auto;
    position: relative;
    right: auto;
    top: auto;
    transform-style: preserve-3d;
    width: auto;

    ${TimelineWrapper} {
      display: none;
    }
  }
`;

export const Perspective = styled.div`
  bottom: 0;
  perspective: 90vw;
  perspective-origin: 74%;
  position: absolute;
  overflow: auto;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 0;

  @media ${breakpoints.MOBILE__MQ} {
    bottom: auto;
    perspective: none;
    perspective-origin: none;
    position: relative;
    right: auto;
    top: auto;
    transform-style: preserve-3d;
    width: 100%;
    overflow: visible;
  }
`;

export const Scroll = styled.div`
  bottom: 0;
  position: absolute;
  right: 0;
  top: 0;

  @media ${breakpoints.MOBILE__MQ} {
    bottom: auto;
    position: relative;
    right: auto;
    top: auto;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0 8vw;
  padding: ${layout.SPACING * 1.75}rem 0;

  @media ${breakpoints.MOBILE__MQ} {
    align-items: center;
    transform-style: preserve-3d;
  }
`;
